import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import { useTheme } from '../contexts/ThemeContext';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = authService.getCurrentUser();
  const isAdmin = authService.isAdmin();
  const { darkMode, toggleDarkMode } = useTheme();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  if (!user) return null;

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        Payroll Shift Schedule Organizer
      </div>
      <div className="navbar-menu">
        <Link to="/dashboard" className={'navbar-link' + (isActive('/dashboard') ? ' active' : '')}>
          Dashboard
        </Link>
        <Link to="/shifts" className={'navbar-link' + (isActive('/shifts') ? ' active' : '')}>
          Shift Records
        </Link>
        {isAdmin && (
          <Link to="/admin" className={'navbar-link' + (isActive('/admin') ? ' active' : '')}>
            Admin
          </Link>
        )}
        <Link to="/settings" className={'navbar-link' + (isActive('/settings') ? ' active' : '')}>
          Settings
        </Link>
        <button onClick={toggleDarkMode} className="theme-toggle" title={darkMode ? 'Light Mode' : 'Dark Mode'}>
          {darkMode ? '☀️' : '🌙'}
        </button>
        <div className="user-info">
          <span className="user-name">{user.name}</span>
          <span className="user-role">{user.role}</span>
          <button onClick={handleLogout} className="btn btn-secondary btn-sm">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
